import { __clear__, __delete__, __resetWrapRect__ } from './db';

// 清空
export function clear(): void {
    __clear__();
    __resetWrapRect__();
}

export function remove(cubeIds: Array<string>): void {
    cubeIds.forEach((cubeId: string): void => {
        __delete__(cubeId);
    });
}
